import { cva } from '@/styled-system/css';

export const progressRangeRecipe = cva({
  base: {
    position: 'absolute',
    zIndex: '2',
    insetBlock: 0,
    insetInlineStart: 0,
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'width',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    transitionTimingFunction: '{easings.ease-in-out}',
  },
  variants: {
    size: {
      md: {
        borderRadius: 'obj.default',
      },
      sm: {
        borderRadius: 'shape.capsule',
      },
    },
    complete: {
      true: {
        backgroundColor: 'ProgressIndicator.bar.track.bg.complete',
      },
      false: {
        backgroundColor: 'ProgressIndicator.bar.track.bg.active',
      },
    },
  },
});
